import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { useAuth } from "./AuthContext";
import { useDemo } from "./DemoContext";
import { getUserRole } from "../services/dataService";
const RoleContext = createContext({
    role: "Salarie",
    realRole: "Salarie",
    loading: true,
    isAdmin: false,
    isSuperUser: false,
    isRH: false,
    isManager: false,
    canAccessRH: false,
    accessDenied: false,
    isDemoMode: false,
    canSimulateRole: false,
});
export const RoleProvider = ({ children }) => {
    const { apiToken: accessToken, userEmail, isLoading: authLoading } = useAuth();
    const { demoUser } = useDemo();
    const [realRole, setRealRole] = useState("Salarie");
    const [loading, setLoading] = useState(true);
    const [accessDenied, setAccessDenied] = useState(false);
    useEffect(() => {
        // Attendre que l'auth MSAL soit complètement terminée avant de décider
        if (authLoading)
            return;
        if (!accessToken) {
            setLoading(false);
            return;
        }
        (async () => {
            setLoading(true);
            try {
                const role = await getUserRole(accessToken, userEmail);
                setRealRole(role);
                setAccessDenied(false);
            }
            catch {
                setRealRole("Salarie");
                setAccessDenied(true);
            }
            finally {
                setLoading(false);
            }
        })();
    }, [accessToken, userEmail, authLoading]);
    const canSimulateRole = realRole === "Admin" || realRole === "SuperUser";
    const effectiveRole = demoUser && canSimulateRole ? demoUser.role : realRole;
    const value = useMemo(() => {
        const isAdmin = effectiveRole === "Admin";
        const isSuperUser = isAdmin || effectiveRole === "SuperUser";
        const isRH = isSuperUser || effectiveRole === "RH";
        const isManager = isRH || effectiveRole === "Manager";
        return {
            role: effectiveRole,
            realRole,
            loading,
            isAdmin,
            isSuperUser,
            isRH,
            isManager,
            canAccessRH: isManager,
            accessDenied,
            isDemoMode: !!demoUser && canSimulateRole,
            canSimulateRole,
        };
    }, [effectiveRole, realRole, loading, accessDenied, demoUser, canSimulateRole]);
    return _jsx(RoleContext.Provider, { value: value, children: children });
};
export const useRole = () => useContext(RoleContext);
